import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import Application from './scenes/Application';
import { render } from 'react-dom';
import reduxThunk from 'redux-thunk';
import reducer from './data/reducer';

document.addEventListener('DOMContentLoaded', () => {
  const reduxTools = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' && reduxTools ? reduxTools : compose;
  const store = createStore(reducer, composeEnhancers(applyMiddleware(reduxThunk)));

  render(
    <Provider store={store}>
      <BrowserRouter>
        <Application/>
      </BrowserRouter>
    </Provider>,
    document.getElementById('application'));
});
